import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./contas.component.html')
})
export class ContasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/contas/contas.component.ts
 **/